import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Slider.css";
import styled from "styled-components";
import { SuspenseImg } from "../../SuspenseImage/SuspenseImage";
import { Link } from "react-router-dom";

const options = {
  loop: true,
  autoplay: true,

  nav: true,
  center: true,
  //   stagePadding: 50,
  margin: 10,

  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    800: {
      items: 2,
    },
    1000: {
      items: 4,
    },
  },
};

const contentStyle = {
  height: "350px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
  width: "100vw",
  backgroundRepeat: "no-repeat",
};

const Slider = ({ games }) => {
  // console.log("Slider Item ", games);
  return (
    <OwlCarousel className="owl-theme" {...options}>
      {games.map((item) => (
        <ImageStyled key={item.id}>
          {/* <Link to={`/video/${item.id}`}> */}
          <Link to="">
            <SuspenseImg key={"S"+item.id}
              style={contentStyle}
              src={item.imageUrl}
              alt={item.name}
            />
          </Link>
         {/* <p style={{ color: "white", padding: "5px", textAlign: "center"}}>{item.name}</p> */}
        </ImageStyled>
      ))}
    </OwlCarousel>
  );
};

export default React.memo(Slider);

const ImageStyled = styled.div`
  img {
    /* object-fit: contain !important; */
    /* position: absolute !important; */
    display: inline-block !important;
    vertical-align: middle !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    overflow: hidden !important;
    width: 100% !important;
    margin-top: 5px !important;
  }
`;
